import React from 'react';

// (26 Sep 2026) One shared look for the app's pop-up messages, replacing
// several copies of the same markup (DashboardStep, MemberCalendarStep,
// PollPage, PollResultsPage, App.js). The message object comes from
// App.js's showStatus: { text, type, seconds, dismissible, dismiss }.
//   - success: blue with a tick; info: blue; error: red with a warning sign
//   - dismissible (errors, or anything shown 8 s or more): a × to close it
//   - seconds: a last line saying when the message will disappear
// placement 'bottom' is for the full-page profile-completion screen, where
// a message must sit near its Save button rather than mid-screen.
export default function StatusToast({ statusMessage, placement = 'center' }) {
  if (!statusMessage?.text) return null;
  const { text, type, seconds, dismissible, dismiss } = statusMessage;
  const canClose = !!(dismissible && typeof dismiss === 'function');

  const box = (
    <div
      role={type === 'error' ? 'alert' : 'status'}
      className={`relative pointer-events-auto mx-4 px-6 py-4 rounded-lg shadow-2xl text-center font-medium text-white max-w-md ${
        type === 'error' ? 'bg-red-600' : 'bg-blue-600'
      } ${canClose ? 'pr-10' : ''}`}
    >
      {canClose && (
        <button
          type="button"
          onClick={dismiss}
          aria-label="Close this message"
          className="absolute top-1 right-2 text-2xl leading-none px-1 opacity-80 hover:opacity-100"
        >
          ×
        </button>
      )}
      <div className="flex items-center gap-3 justify-center">
        {type === 'success' && (
          <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        )}
        {type === 'error' && (
          <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        )}
        <span className="text-lg">{text}</span>
      </div>
      {seconds ? (
        <p className="text-xs font-normal opacity-80 mt-2">
          This message will disappear after {seconds} second{seconds === 1 ? '' : 's'}.
        </p>
      ) : null}
    </div>
  );

  if (placement === 'bottom') {
    return <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[60] w-full max-w-md flex justify-center">{box}</div>;
  }
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none">
      {box}
    </div>
  );
}
